import Chart from "react-apexcharts";
import { useState } from "react";
import type { ApexOptions } from "apexcharts";
import type { components } from "../../helper";

export default function ColumnChart({
  data,
}: {
  data?: components["schemas"]["SiteDashboardPurchaseChartItem"];
}) {
  const [state] = useState<{
    series: ApexOptions["series"];
    options: ApexOptions;
  }>({
    series: [
      {
        name: "محصول",
        data:
          data?.purchase_chart_month_products_count?.map((e) => e.count) ?? [],
      },
      {
        name: "دوره",
        data:
          data?.purchase_chart_month_courses_count.map((e) => e.count) ?? [],
      },
    ],
    options: {
      chart: {
        type: "bar" as const,
        stacked: true,
        fontFamily: "YekanBakh-semiBold",
        width: "100%",
        id: "bar12",
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: true,
        },
      },
      colors: ["#255CFF", "#8EB7FF"],
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          borderRadius: 4,
          rangeBarOverlap: true,
          colors: {
            backgroundBarRadius: 20,
          },
          isFunnel3d: true,
          columnWidth: 30,
          dataLabels: {
            total: {
              enabled: false,
            },
          },
        },
      },
      yaxis: {
        min: 0,
        tickAmount: 5,
        labels: {
          formatter: function (val) {
            return val.toString();
          },
        },
      },
      xaxis: {
        type: "category",
        categories: [
          "فروردین",
          "اردیبهشت",
          "خرداد",
          "تیر",
          "مرداد",
          "شهریور",
          "مهر",
          "آبان",
          "آذر",
          "دی",
          "بهمن",
          "اسفند",
        ],
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        offsetY: 0,
        markers: {
          shape: "circle",
        },
      },
      fill: {
        opacity: 1,
      },
    },
  });

  return (
    <div className="flex w-full bar-chart container-chart h-80">
      <Chart
        options={state.options}
        series={state.series}
        type="bar"
        height="100%"
        width="100%"
      />
    </div>
  );
}
